export class ApiError extends Error {
  private content: any;

  constructor(message: string, content?: any) {
    super(message);
    this.name = ApiError.name;
    this.content = content;
  }

  get prop(): any {
    return this.content;
  }
}
